<template>
  <div class="download">
    <div class="download_content">
      <h2>
        Download<br />
        the App
      </h2>
      <p>Get the app now and have access to premium doggie care</p>
      <div class="download_content_stores">
        <a href="#" class="store">
          <img src="../assets/images/getPlaystore.png" alt="" />
        </a>
        <a href="#" class="store">
          <img src="../assets/images/getAppleStore.png" alt="" />
        </a>
      </div>
    </div>
    <div class="download_app">
      <div class="download_app_image">
        <img src="../assets/images/phone.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Download",
};
</script>

<style lang="scss" src="../styles/download.scss"></style>
